<!--
    Running: no footer and no close icon. There is no cancel on the route, so a close button would only
    hide a request that keeps writing.
-->
<ham-modal
    *ngIf="isLoading"
    [title]="'abcp.accountSurface.syncRunningTitle' | i18next"
    [hideFooter]="true"
    [showCloseIcon]="false"
    size="sm"
>
    <div class="erp-progress">
        <div class="erp-progress__logos">
            <img
                *ngIf="vendor as erp"
                class="erp-progress__logo erp-progress__logo--vendor"
                [src]="erp.logoSrc"
                [alt]="erp.name"
            />
            <span class="erp-progress__arrow" *ngIf="vendor !== null" aria-hidden="true">→</span>
            <img class="erp-progress__logo" src="/assets/icons/aumico-logo-small.svg" alt="aumico" />
        </div>

        <!-- Indeterminate on purpose: the vendor reports no progress, and a bar that filled at its own
             pace would be a picture of nothing. -->
        <div class="erp-progress__bar-wrap">
            <div class="erp-progress__bar"></div>
        </div>

        <div class="erp-progress__subtitle">{{ 'abcp.accountSurface.syncRunningSubtitle' | i18next }}</div>
        <div class="erp-progress__hint">{{ 'abcp.accountSurface.syncRunningHint' | i18next }}</div>
    </div>
</ham-modal>

<ham-modal
    *ngIf="!isLoading && summary as done"
    [title]="'abcp.accountSurface.syncDoneTitle' | i18next"
    size="sm"
    [showCloseIcon]="true"
    [showCancelButton]="false"
    [saveText]="'abcp.accountSurface.syncDoneClose' | i18next"
    (cancel)="onClose()"
    (save)="onClose()"
>
    <div class="erp-progress">
        <div class="erp-progress__done" [class.erp-progress__done--warn]="hasFailure">
            {{
                (hasFailure ? 'abcp.accountSurface.syncDonePartly' : 'abcp.accountSurface.syncDoneAll') | i18next
            }}
        </div>

        <dl class="erp-progress__facts">
            <dt>{{ 'abcp.accountSurface.syncDonePeriod' | i18next }}</dt>
            <dd>{{ done.period }}</dd>

            <dt>{{ 'abcp.accountSurface.syncDoneAccounts' | i18next }}</dt>
            <dd>{{ done.accountsInErp }}</dd>

            <!-- Only when there are any: a zero here would read as a finding rather than as "the ERP's
                 chart and the journal agreed". -->
            <ng-container *ngIf="done.accountsJournalOnly > 0">
                <dt>{{ 'abcp.accountSurface.syncDoneJournalOnly' | i18next }}</dt>
                <dd>{{ done.accountsJournalOnly }}</dd>
            </ng-container>

            <ng-container *ngIf="done.statesCreated > 0">
                <dt>{{ 'abcp.accountSurface.syncDoneStatesCreated' | i18next }}</dt>
                <dd>{{ done.statesCreated }}</dd>
            </ng-container>
        </dl>

        <div
            class="erp-progress__notice"
            *ngIf="done.vatDocumentsUnreadable > 0"
            data-testid="erp-sync-vat-unreadable"
        >
            {{ 'abcp.accountSurface.syncDoneVatUnreadable' | i18next: { count: done.vatDocumentsUnreadable } }}
        </div>

        <div class="erp-progress__periods" *ngIf="hasComparisonPeriods">
            <div class="erp-progress__periods-label">
                {{ 'abcp.accountSurface.syncDoneComparisons' | i18next }}
            </div>
            <div
                class="erp-progress__period"
                *ngFor="let period of done.comparisonPeriods"
                [class.erp-progress__period--failed]="period.failed"
            >
                <span class="erp-progress__period-name">{{ period.label }}</span>
                <span class="erp-progress__period-outcome">{{ period.outcome }}</span>
            </div>
        </div>
    </div>
</ham-modal>
